const gigDisputes = [
	{
		path: '/jobs/gig-disputes/list',
		name: 'jobs-gig-disputes-list',
		component: () => import('@/views/jobs/gig-disputes/list.vue'),
		meta: { layout: 'content', module: 'MGJ,gigs' },
	},
]

export default gigDisputes
